export const city_articles = [
    {
        image_url: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/DK22OZLOF5FH3NKZPO4NSIETLQ.jpg",
        article_title: "Meet the New York Interfaith Commission, Harlem's advocate for affordable housing",
        article_authors: "Thomas Stewart",
        article_link: "https://www.columbiaspectator.com/city-news/2025/02/11/meet-the-new-york-interfaith-commission-harlems-advocate-for-affordable-housing/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/XGOFJUM6BRCTZI4DJW3SA2WLNM.JPG?auth=12fa87d6c436a1404f108bc38946a902190706766e35480a535a6bcc948d3a4c",
        article_title: "Edafe Okporo gains traction in local District 7 race",
        article_authors: "Tsehai Alfred",
        article_link: "https://www.columbiaspectator.com/city-news/2025/02/11/edafe-okporo-gains-traction-in-local-district-7-race/"
    }
];
